// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import Vant from 'vant';
import 'vant/lib/index.css';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import App from './App';
import router from './router';
import store from './store/index';
import axios from 'axios';
// import {get, post, patch, put} from '../config/axios'
import CryptoJS from 'crypto-js';
import VueTouch from 'vue-touch';

Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(CryptoJS);
Vue.use(VueTouch, {name: 'v-touch'});
router.afterEach(() => {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
});

Vue.prototype.$axios = axios;
// Vue.prototype.$get = get;
// Vue.prototype.$post = post;
// Vue.prototype.$patch = patch;
// Vue.prototype.$put = put;
Vue.config.productionTip = false;
/* eslint-disable no-new */
// 环境的切换
if (process.env.NODE_ENV === 'development') {
    axios.defaults.baseURL = '/api';
} else if (process.env.NODE_ENV === 'debug') {
    axios.defaults.baseURL = '';
} else if (process.env.NODE_ENV === 'production') {
    // axios.defaults.baseURL = 'https://www.1xgj.com/ipms/';
    axios.defaults.baseURL = 'http://119.27.160.213:8087/web/'; //测试环境
}


// 请求超时时间
axios.defaults.timeout = 10000;

// 请求拦截器
axios.interceptors.request.use(
    config => {
        // config.data = qs.stringify(config.data);
        config.headers = {
            // 'Content-Type':'application/x-www-form-urlencoded'
            'Content-Type':'application/json'
        };
        return config;
    },
    error => {
        return Promise.reject(error);
    });

// 响应拦截器
axios.interceptors.response.use(
    response => {
        //拦截响应，做统一处理
        // if (response.data.code) {
        // }
        return response;
    },
    // 服务器状态码不是200的情况
    error => {
        return Promise.reject(error.response.status); // 返回接口返回的错误信息
    }
);
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js